export const FIELDS = [
  { fieldName: 'Name', placeholder: 'School name' },
  { fieldName: 'Domain', placeholder: 'School domain' },
  { fieldName: 'Abbreviation', placeholder: 'School abbreviation' },
];
